import { getPathBySearchObj } from '../../../../widget/spec/searchHelper';
import { getStorage, setStorage } from './_localstorage.js';
import { setCookie, getCookie } from '../nojq/_cookie.js';
import { browserType as getBrowserType } from '../nojq/_browser.js';
import { yieldToMain, gaEventTrack } from '../../directives/_gtm.directive.js';
import { getIANAtimeZone } from './_utilities.js';
const isSSR = typeof window === 'undefined';
let context = !isSSR ? window.__INITIAL_STATE__ : undefined;
// Variables that will be reassigned
let notificationInitialed = false;
let supportServiceWork = false;
let anonymousId;
let safariNotification;
let browserType;
let isSafari;
let defaultPayload;
let defaultNotificationOptions;

function importFireBaseApp() {
    return import(/* webpackChunkName: "firebase-sdk" */ 'firebase/app');
}

function importFireBaseMessaging() {
    return import(/* webpackChunkName: "firebase-sdk" */ 'firebase/messaging');
}

function fixedThreeDigits(value) {
    const num = Math.round(value);
    if (num < 10) {
        return Math.round(value * 100) / 100;
    } else if (num < 100) {
        return Math.round(value * 10) / 10;
    }
    return num;
}

function friendlyPrice(value) {
    const amount = Math.abs(value);
    if (amount >= 1000 && amount < 1000000) {
        return fixedThreeDigits(amount / 1000) === 1000 ? '1M' : fixedThreeDigits(amount / 1000).toFixed(0) + 'K';
    } else if (amount >= 1000000 && amount < 1000000000) {
        if (fixedThreeDigits(amount / 1000000) === 1000) {
            return '1B';
        }
        const valueNum = fixedThreeDigits(amount / 1000000).toFixed(1);
        const strValue = valueNum.toString();
        return fixedThreeDigits(amount / 1000000).toFixed(strValue.lastIndexOf('0') === strValue.length - 1 ? 0 : 1) + 'M';
    } else if (amount >= 1000000000) {
        return fixedThreeDigits(amount / 1000000000).toFixed(1) + 'B';
    }
    return amount;
}

function mergeArray(a1, a2) {
    let array = [];
    if (Array.isArray(a1)) {
        if (Array.isArray(a2)) {
            array = a1.concat(a2);
        } else {
            return a1;
        }
    } else if (Array.isArray(a2)) {
        return a2;
    } else {
        return [];
    }
    const a = array.concat();
    for (let i = 0; i < a.length; ++i) {
        for (let j = i + 1; j < a.length; ++j) {
            if (a[i] === a[j]) {
                a.splice(j--, 1);
            }
        }
    }
    return a;
}

function getRegSW() {
    return new Promise((resolve) => {
        navigator.serviceWorker.ready
            .then(function () {
                navigator.serviceWorker
                    .getRegistrations()
                    .then(function (registrations) {
                        for (const key in registrations) {
                            const regSW = registrations[key];
                            if (regSW.active && regSW.active.scriptURL === context.appUrl + 'firebase-messaging-sw.js') {
                                resolve(regSW);
                            }
                        }
                        resolve(null);
                    })
                    .catch(function () {
                        resolve(null);
                    });
            })
            .catch(function () {
                resolve(null);
            });
    });
}



function addNotificationInitializedListener(callback) {
    if (notificationInitialed) {
        callback();
    } else {
        const handler = function () {
            callback();
            document.removeEventListener('notificatinInitialed', handler);
        };
        document.addEventListener('notificatinInitialed', handler, { once: true });
    }
}

function importFireBase() {
    return new Promise((resolve) => {
        importFireBaseMessaging()
            .then(({ getMessaging, isSupported, getToken, onMessage }) => {
                if (isSupported()) {
                    return importFireBaseApp().then(({ initializeApp }) => {
                        const app = initializeApp(context.firebaseMessaging.chrome);
                        resolve({
                            firebaseMessaging: getMessaging(app),
                            getToken,
                            onMessage,
                        });
                    });
                } else {
                    gaEventTrack({
                        category: 'pushNotification',
                        action: 'pushNotification',
                        label: 'NotificationFirebaseNotSupport',
                    });
                    resolve(null);
                }
            })
            .catch((error) => {
                console.error('Firebase Messaging import failed:', error);
                resolve(null);
            });
    });
}

function syncBySubscriptions(data) {
    let record = getRecords();
    record = data.reduce(function (prev, next) {
        const newRecord = _subscriptionToRecord(next);
        if (newRecord && newRecord.zipcode) {
            const i = prev.findIndex(function (e) {
                return e.zipcode == newRecord.zipcode;
            });
            if (i >= 0) {
                const item = prev[i];
                //sync disable flag and propertyType
                item.disabled = newRecord.disabled;
                item.propertyType = mergeArray(item.propertyType, newRecord.propertyType);
                //only sync bed price when client side don't have the data
                item.minBed = newRecord.minBed || item.minBed;
                item.maxBed = newRecord.maxBed || item.maxBed;
                item.minPrice = newRecord.minPrice || item.minPrice;
                item.maxPrice = newRecord.maxPrice || item.maxPrice;
                item.stateCode = newRecord.stateCode || item.stateCode;
            } else {
                prev.push(newRecord);
            }
        }
        return prev;
    }, record);
    setStorage('saveSearchRecord', record);
}

function formatDate(t) {
    const year = t.getFullYear();
    return year + '' + (1 + t.getMonth()) + '' + t.getDate();
}

function updatePushNotificationToken(token) {
    const saveSearchRecordSyncDate = getStorage('saveSearchRecordSyncDate');
    const currentDate = formatDate(new Date());
    const localToken = getCookie('pushToken');
    if (token && localToken === token) {
        if (saveSearchRecordSyncDate === currentDate) {
            return;
        }
        //sync saveSearchRecord
        _getSubscriptionTrack()
            .then(function (res) {
                const arr = (res.data && res.data.pushNotificationRecord) || res.data;
                if (arr && arr.length) {
                    syncBySubscriptions(arr);
                    setStorage('saveSearchRecordSyncDate', currentDate);
                }
            })
            .finally(function () {
                callSubscribe(token);
            });
    } else {
        callSubscribe(token);
    }
}

function callSubscribe(token) {
    const data = Object.assign(defaultPayload, { token: token });
    if (!token || token === 'null') {
        console.error('No Subscribe Token Found!');
        return;
    }
    setCookie('pushToken', token);
    const url = `${context.appUrl}api/pushnotification/subscribe/`;
    const body = JSON.stringify(data);
    fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8',
        },
        body,
    });
}

function requestNotificationsPermissions() {
    return new Promise((resolve) => {
        gaEventTrack({
            category: 'pushNotification',
            action: 'pushNotification',
            label: 'notificationStart',
        });
        try {
            if (safariNotification) {
                const config = context.firebaseMessaging.safari;
                window.safari.pushNotification.requestPermission(context.appUrl.replace(/\/$/, ''), config.pushId, {}, function (e) {
                    if (e.permission === 'granted') {
                        gaEventTrack({
                            category: 'pushNotification',
                            action: 'pushNotification',
                            label: 'notificationAllowed',
                            name: 'notification_accepted',
                        });
                        resolve(true);
                    } else {
                        gaEventTrack({
                            category: 'pushNotification',
                            action: 'pushNotification',
                            label: 'notificationDenied',
                        });
                        resolve(false);
                    }
                });
            } else {
                resolve(false);
            }
        } catch (err) {
            gaEventTrack({
                category: 'pushNotification',
                action: 'pushNotification',
                label: 'notificationDenied',
            });
            resolve(false);
        }
    });
}

function getCurrentToken(firebaseUtils) {
    return new Promise((resolve) => {
        if (safariNotification) {
            const config = context.firebaseMessaging.safari;
            const permissionData = window.safari.pushNotification.permission(config.pushId);
            if (permissionData.permission === 'granted') {
                resolve(permissionData.deviceToken);
            } else if (permissionData.permission === 'denied') {
                resolve(null);
            } else {
                requestNotificationsPermissions()
                    .then(function (allowed) {
                        if (allowed) {
                            getCurrentToken(firebaseUtils).then(function (e) {
                                resolve(e);
                            });
                        } else {
                            resolve(null);
                        }
                    })
                    .catch(function (err) {
                        console.error('Unable to get messaging token.', err);
                        gaEventTrack({
                            category: 'pushNotification',
                            action: 'pushNotification',
                            label: 'notificationError',
                        });
                        resolve(null);
                    });
            }
        } else {
            if (checkBlocked()) {
                resolve(null);
            }
            const permissionDefault = checkPermission() === 'default';
            getChromeToken(firebaseUtils)
                .then((currentToken) => {
                    if (permissionDefault && checkAllowed()) {
                        gaEventTrack({
                            category: 'pushNotification',
                            action: 'pushNotification',
                            label: 'notificationAllowed',
                            name: 'notification_accepted',
                        });
                    }
                    resolve(currentToken);
                })
                .catch(function (err) {
                    let eventName = 'notificationError';
                    if (err && err.code === 'messaging/permission-blocked') {
                        eventName = 'notificationDenied';
                    }
                    gaEventTrack({
                        category: 'pushNotification',
                        action: 'pushNotification',
                        label: eventName,
                    });
                    resolve(null);
                });
        }
    });
}

function getChromeToken(firebaseUtils) {
    const config = context.firebaseMessaging.chrome;
    return firebaseUtils.getToken(firebaseUtils.firebaseMessaging, { vapidKey: config.publicKey });
}

function showLocalNotification(options) {
    if (!safariNotification) {
        //this is local notification
        getRegSW().then(function (registration) {
            registration && registration.showNotification(options.title, options.param);
        });
    } else {
        //this is push notification
        const notification = new window.Notification(options.title, options.param);
        notification.addEventListener('close', function () {
            gaEventTrack({
                category: 'pushNotification',
                action: 'pushNotification',
                label: 'notificationBoxClose',
            });
        });
        notification.addEventListener('show', function () {
            gaEventTrack({
                category: 'pushNotification',
                action: 'pushNotification',
                label: 'notificationBoxShow',
            });
        });
        notification.addEventListener('click', function () {
            gaEventTrack({
                category: 'pushNotification',
                action: 'pushNotification',
                label: 'notificationBoxClick',
            });
            notification.close();
            window.open(options.param.data.url, '_blank');
        });
        notification.addEventListener('error', function () {
            gaEventTrack({
                category: 'pushNotification',
                action: 'pushNotification',
                label: 'notificationBoxError',
            });
        });
    }
}

function pushNotificationInitializeFirebase(firebaseUtils) {
    // Initialize Firebase
    firebaseUtils.onMessage(firebaseUtils.firebaseMessaging, function (message) {
        const payload = message.data;
        if (!payload.tag) {
            const dt = new Date();
            payload.tag = dt.getFullYear() + '-' + dt.getMonth() + '-' + dt.getDate() + '-' + dt.getHours() + '-' + dt.getMinutes();
        }
        const notificationTitle = payload.title || 'Movoto Message',
            notificationOptions = {
                body: payload.body,
                icon: payload.image || defaultNotificationOptions.icon,
                data: {
                    url: payload.clickAction || defaultNotificationOptions.url,
                    zipcode: payload.zipcode,
                    urlUtmTerm: payload.urlUtmTerm,
                },
                tag: payload.tag,
                requireInteraction: true,
            };

        if ('actions' in Notification.prototype) {
            notificationOptions.actions = [
                {
                    action: 'openurl',
                    title: 'View House',
                },
                {
                    action: 'unsubscribe',
                    title: 'Unsubscribe',
                },
            ];
        }

        showLocalNotification({
            title: notificationTitle,
            param: notificationOptions,
        });
    });
}

function initNotificationSafari() {
    yieldToMain();
    if (safariNotification) {
        getCurrentToken()
            .then(function (tokenStored) {
                if (tokenStored) {
                    updatePushNotificationToken(tokenStored);
                }
                notificationInitialed = true;
                setTimeout(function () {
                    const event = new CustomEvent('notificatinInitialed', {
                        detail: !!tokenStored,
                    });
                    document.dispatchEvent(event);
                }, 1000);
            })
            .catch(function () {
                const event = new CustomEvent('notificatinInitialed', {
                    detail: false,
                });
                document.dispatchEvent(event);
            });
    } else {
        notificationInitialed = true;
        setTimeout(function () {
            const event = new CustomEvent('notificatinInitialed', {
                detail: false,
            });
            document.dispatchEvent(event);
        }, 1000);
    }
}

function initNotificationChrome(firebaseUtils) {
    yieldToMain();
    if (firebaseUtils) {
        getCurrentToken(firebaseUtils)
            .then(function (tokenStored) {
                if (tokenStored) {
                    pushNotificationInitializeFirebase(firebaseUtils);
                    updatePushNotificationToken(tokenStored);
                }
                notificationInitialed = true;
                setTimeout(function () {
                    const event = new CustomEvent('notificatinInitialed', {
                        detail: !!tokenStored,
                    });
                    document.dispatchEvent(event);
                }, 1000);
            })
            .catch(function () {
                const event = new CustomEvent('notificatinInitialed', {
                    detail: false,
                });
                document.dispatchEvent(event);
            });
    } else {
        notificationInitialed = true;
        setTimeout(function () {
            const event = new CustomEvent('notificatinInitialed', {
                detail: false,
            });
            document.dispatchEvent(event);
        }, 1000);
    }
}

function initNotification() {
    setStorage('lastTime', null);
    let eventName = 'ontouchstart' in window ? 'touchstart' : 'mousedown';
    document.addEventListener(
        eventName,
        function () {
            if (isSafari) {
                initNotificationSafari();
            } else {
                importFireBase().then((firebaseUtils) => {
                    initNotificationChrome(firebaseUtils);
                });
            }
        },
        { once: true }
    );
}

function updateSubscriptionTrack(param) {
    const token = getCookie('pushToken');
    return new Promise((resolve) => {
        if (!defaultPayload.gaId) {
            resolve({ error: 'no gaid' });
        }
        if (token === 'null') {
            resolve({ error: 'not support' });
        } else if (!token) {
            resolve({ error: 'no token' });
        }
        if (!param.zipcode) {
            resolve({ error: 'zipcode is required' });
        }

        const data = Object.assign(defaultPayload, {
            token: token,
            zipcode: param.zipcode || '',
            minBed: param.minBed || 0,
            maxBed: param.maxBed || 0,
            minPrice: param.minPrice || 0,
            maxPrice: param.maxPrice || 0,
            state: param.state,
            propertyType: param.propertyType || [],
            mapSearchUrl: getUrlByRecord(param, true),
            timezone: getIANAtimeZone(),
        });

        const url = `${context.appUrl}api/pushnotification/subscribe/`;
        const body = JSON.stringify(data);
        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
            },
            body,
        })
            .then((response) => response.json())
            .then(function (res) {
                resolve({ success: 1, message: res });
            })
            .catch(function (err) {
                resolve({ error: 'failed', message: err });
            });
    });
}

function changeType(currentRecord, mergeRecord) {
    let type = '';
    if (!currentRecord) {
        type = 'create';
    } else if (currentRecord.propertyType.length !== mergeRecord.propertyType.length) {
        type = 'update';
    } else if (mergeRecord.maxPrice > currentRecord.maxPrice) {
        type = 'maxPrice';
    } else if (mergeRecord.minBed < currentRecord.minBed) {
        type = 'minBed';
    }
    return type;
}

function CreateNotification(record, type) {
    let successTitle, successBody, notificationParam, urlUtmTerm, buttonText, _url, tag;

    if (!record) {
        successTitle = 'Thanks For Allowing Notifications!';
        successBody = 'View Your Notification Settings: Movoto.com/notification';
        buttonText = 'View Settings';
        _url = context.appUrl + 'notification';
        urlUtmTerm = 'first_notification';
        tag = '';
    } else {
        buttonText = 'See Homes';
        _url = getUrlByRecord(record);
        tag = record.zipcode;
        switch (type) {
            case 'create':
                successTitle = record.zipcode + ' Notification Saved';
                successBody = record.propertyTypeDisplayName;
                if (record.maxPrice) {
                    successBody += ' <$' + friendlyPrice(record.maxPrice);
                }
                if (record.minBed) {
                    successBody += ' ' + record.minBed + '+ Bd';
                }
                urlUtmTerm = 'save';
                break;
            case 'update':
                successTitle = record.zipcode + ' Notification Update';
                successBody = record.propertyTypeDisplayName + ' Added';
                if (record.maxPrice) {
                    successBody += ' <$' + friendlyPrice(record.maxPrice);
                }
                if (record.minBed) {
                    successBody += ' ' + record.minBed + '+ Bd';
                }
                urlUtmTerm = 'update';
                break;
            case 'maxPrice':
                successTitle = record.zipcode + ' Notification Update';
                successBody = 'Max Price Increased to $' + friendlyPrice(record.maxPrice);
                urlUtmTerm = 'update';
                break;
            case 'minBed':
                successTitle = record.zipcode + ' Notification Update';
                successBody = 'Min Beds Reduced to ' + record.minBed + 'Bd';
                urlUtmTerm = 'update';
                break;
        }
        successBody += ' in ' + record.zipcode;
    }
    if (!successTitle) {
        return;
    }

    notificationParam = {
        body: successBody,
        icon: defaultNotificationOptions.icon,
        data: {
            url: _url,
            zipcode: record && record.zipcode,
            term: urlUtmTerm,
        },
        tag: tag,
        requireInteraction: true,
    };
    notificationParam.data.url += '?utm_medium=notification&utm_campaign=realtime&utm_source=web-push&utm_term=' + urlUtmTerm;
    if ('actions' in Notification.prototype) {
        notificationParam.actions = [
            {
                action: 'openurl',
                title: buttonText,
            },
            {
                action: 'unsubscribe',
                title: 'Unsubscribe',
            },
        ];
    }
    showLocalNotification({
        title: successTitle,
        param: notificationParam,
    });
}

function _updateSubscriptionBySubscription(subscription) {
    return new Promise((resolve) => {
        const savesearchRecord = getRecords();
        const currentRecord = savesearchRecord.find(function (e) {
            return e.zipcode == subscription.zipcode;
        });
        if (!currentRecord) {
            resolve(false);
        }
        if (subscription) {
            updateSubscriptionTrack(subscription).then(function (response) {
                if (!response.error || response.error === 'not support') {
                    currentRecord.maxPrice = subscription.maxPrice;
                    currentRecord.minPrice = subscription.minPrice;
                    currentRecord.maxBed = subscription.maxBed;
                    currentRecord.minBed = subscription.minBed;
                    currentRecord.propertyType = subscription.propertyType;
                    currentRecord.updateTime = new Date();
                    gaEventTrack({
                        category: 'pushNotification',
                        action: 'pushNotification',
                        label: 'notificationSubscriptionEdit',
                    });
                    setStorage('saveSearchRecord', savesearchRecord);
                    _refreshUI();
                    resolve(true);
                } else {
                    resolve(false);
                }
            });
        }
    });
}

function _updateSubscriptionByListing(listing) {
    return new Promise((resolve) => {
        if (getStorage('disableNotification') || listing.isRentals) {
            resolve(false);
        }
        const newRecord = _listingToRecord(listing);
        if (!newRecord) {
            resolve(false);
        }
        const savesearchRecord = getRecords();
        const i = savesearchRecord.findIndex(function (e) {
            return e.zipcode == newRecord.zipcode;
        });
        const currentRecord = i >= 0 ? savesearchRecord[i] : null;
        const mergeRecord = _updateRecord(currentRecord, newRecord);
        const type = changeType(currentRecord, mergeRecord);
        if (type) {
            const subscription = _recordToSubscription(mergeRecord);
            if (subscription) {
                updateSubscriptionTrack(subscription).then(function (response) {
                    if (type && !mergeRecord.disabled) {
                        CreateNotification(mergeRecord, type);
                    }
                    if (!response.error || response.error === 'not support') {
                        if (type === 'create') {
                            savesearchRecord.push(mergeRecord);
                        } else {
                            savesearchRecord[i] = mergeRecord;
                        }
                        setStorage('saveSearchRecord', savesearchRecord);
                        _refreshUI();
                        resolve(true);
                    } else {
                        resolve(false);
                    }
                });
            }
        } else {
            resolve(false);
        }
    });
}

function enableSubscriptionTrack(param) {
    const token = getCookie('pushToken');
    return new Promise((resolve) => {
        if (!defaultPayload.gaId) {
            resolve({ error: 'no gaid' });
        }
        if (token === 'null') {
            resolve({ error: 'not support' });
        } else if (!token) {
            resolve({ error: 'no token' });
        }
        if (!Array.isArray(param.zipcodes) && param.zipcodes.length) {
            resolve({ error: 'zipcode is required' });
        }
        const data = Object.assign(defaultPayload, {
            token: token,
            zipcodes: param.zipcodes,
            isAllowPushNotification: true,
        });

        const url = `${context.appUrl}api/pushnotification/subscriptions/enabledisable/useroptions/`;
        const body = JSON.stringify(data);
        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
            },
            body,
        })
            .then((response) => response.json())
            .then(function (res) {
                resolve({ success: 1, message: res });
            })
            .catch(function (err) {
                resolve({ error: 'failed', message: err });
            });
    });
}

function _enableSubscription(param) {
    return new Promise((resolve) => {
        const savesearchRecord = getRecords();
        enableSubscriptionTrack(param).then(function (response) {
            if (!response.error || response.error === 'not support') {
                const zipcodes = new RegExp('(' + param.zipcodes.join('|') + ')');
                savesearchRecord.forEach(function (e) {
                    if (zipcodes.test(e.zipcode)) {
                        e.disabled = false;
                    }
                });
                gaEventTrack({
                    category: 'pushNotification',
                    action: 'pushNotification',
                    label: 'notificationSubscriptionActive',
                });
                setStorage('saveSearchRecord', savesearchRecord);
                _refreshUI();
                resolve(true);
            } else {
                resolve(false);
            }
        });
    });
}

function allowSubscriptionsTrack(isAllowPushNotification) {
    const token = getCookie('pushToken');
    return new Promise((resolve) => {
        if (!defaultPayload.gaId) {
            resolve({ error: 'no gaid' });
        }
        if (token === 'null') {
            resolve({ error: 'not support' });
        } else if (!token) {
            resolve({ error: 'no token' });
        }

        const data = Object.assign(defaultPayload, {
            token: token,
            isAllowPushNotification: isAllowPushNotification,
        });

        const url = `${context.appUrl}api/pushnotification/unsubscribe/notification/all/`;
        const body = JSON.stringify(data);
        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
            },
            body,
        })
            .then((response) => response.json())
            .then(function (res) {
                resolve({ success: 1, message: res });
            })
            .catch(function (err) {
                resolve({ error: 'failed', message: err });
            });
    });
}

function allowSubscriptions(isAllowPushNotification) {
    return new Promise((resolve) => {
        const savesearchRecord = getRecords();
        allowSubscriptionsTrack(isAllowPushNotification).then(function (response) {
            if (!response.error || response.error === 'not support') {
                savesearchRecord.forEach(function (e) {
                    e.disabled = !isAllowPushNotification;
                });
                setStorage('disableNotification', !isAllowPushNotification);
                setStorage('saveSearchRecord', savesearchRecord);
                _refreshUI();
                resolve(true);
            } else {
                resolve(false);
            }
        });
    });
}

function disableSubscriptionTrack(param) {
    const token = getCookie('pushToken');
    return new Promise((resolve) => {
        if (!defaultPayload.gaId) {
            resolve({ error: 'no gaid' });
        }
        if (token === 'null') {
            resolve({ error: 'not support' });
        } else if (!token) {
            resolve({ error: 'no token' });
        }
        if (!Array.isArray(param.zipcodes) && param.zipcodes.length) {
            resolve({ error: 'zipcode is required' });
        }
        const data = Object.assign(defaultPayload, {
            token: token,
            zipcodes: param.zipcodes,
            isAllowPushNotification: false,
        });

        const url = `${context.appUrl}api/pushnotification/subscriptions/enabledisable/useroptions/`;
        const body = JSON.stringify(data);
        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
            },
            body,
        })
            .then((response) => response.json())
            .then(function (res) {
                resolve({ success: 1, message: res });
            })
            .catch(function (err) {
                resolve({ error: 'failed', message: err });
            });
    });
}

function deleteSubscriptionTrack(param) {
    const token = getCookie('pushToken');
    return new Promise((resolve) => {
        if (!defaultPayload.gaId) {
            resolve({ error: 'no gaid' });
        }
        if (token === 'null') {
            resolve({ error: 'not support' });
        } else if (!token) {
            resolve({ error: 'no token' });
        }
        if (!Array.isArray(param.zipcodes) && param.zipcodes.length) {
            resolve({ error: 'zipcode is required' });
        }
        const data = Object.assign(defaultPayload, {
            token: token,
            zipcodes: param.zipcodes,
        });

        const url = `${context.appUrl}api/pushnotification/deletenotifications/`;
        const body = JSON.stringify(data);
        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
            },
            body,
        })
            .then((response) => response.json())
            .then(function (res) {
                resolve({ success: 1, message: res });
            })
            .catch(function (err) {
                resolve({ error: 'failed', message: err });
            });
    });
}

function _deleteSubscription(param) {
    return new Promise((resolve) => {
        const savesearchRecord = getRecords();
        deleteSubscriptionTrack(param).then(function (response) {
            if (!response.error || response.error === 'not support') {
                const zipcodes = new RegExp('(' + param.zipcodes.join('|') + ')');
                const newsavesearchRecord = savesearchRecord.filter((e) => !zipcodes.test(e.zipcode));
                gaEventTrack({
                    category: 'pushNotification',
                    action: 'pushNotification',
                    label: 'notificationSubscriptionInactive',
                });
                setStorage('saveSearchRecord', newsavesearchRecord);
                _refreshUI();
                resolve(true);
            } else {
                resolve(false);
            }
        });
    });
}

function _disableSubscription(param) {
    return new Promise((resolve) => {
        const savesearchRecord = getRecords();
        disableSubscriptionTrack(param).then(function (response) {
            if (!response.error || response.error === 'not support') {
                const zipcodes = new RegExp('(' + param.zipcodes.join('|') + ')');
                savesearchRecord.forEach(function (e) {
                    if (zipcodes.test(e.zipcode)) {
                        e.disabled = true;
                    }
                });
                gaEventTrack({
                    category: 'pushNotification',
                    action: 'pushNotification',
                    label: 'notificationSubscriptionInactive',
                });
                setStorage('saveSearchRecord', savesearchRecord);
                _refreshUI();
                resolve(true);
            } else {
                resolve(false);
            }
        });
    });
}

function _valideBed(type) {
    const _validateBedRex = /(MULTI_FAMILY|LAND|OTHER)/;
    if (Array.isArray(type)) {
        return type.some(function (val) {
            return !_validateBedRex.test(val);
        });
    }
    return !_validateBedRex.test(type);
}

function _getUrlByRecord(record, withoutDomain) {
    const stateCode = record.stateCode || record.state;
    if (!record || !record.zipcode || !stateCode) {
        return context.appUrl + 'for-sale/';
    }
    const geo = {
        zipcode: record.zipcode,
        stateCode: stateCode,
    };
    const filter = {
        propertyType: record.propertyType,
        minBed: record.minBed,
        maxPrice: record.maxPrice,
    };
    const path = getPathBySearchObj(geo, filter);
    return (withoutDomain ? '' : context.appUrl) + path;
}

function _getSubscriptionTrack() {
    const token = getCookie('pushToken');
    return new Promise((resolve) => {
        if (!defaultPayload.gaId) {
            resolve({ error: 'no gaid' });
        }

        //incase of the blocked or no access given.
        if (token === 'null') {
            resolve({ error: 'not support' });
        } else if (!token) {
            resolve({ error: 'no token' });
        }

        const url = `${context.appUrl}api/pushnotification/activenotification/gaid/token/`;

        const data = Object.assign(defaultPayload, { token: token });
        const body = JSON.stringify(data);
        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
            },
            body,
        })
            .then((response) => response.json())
            .then(resolve)
            .catch((err) => {
                resolve({ error: 'failed', message: err });
            });
    });
}

function _getRecords() {
    //if we have old data
    let records = getStorage('saveSearchRecord');
    if (!records) {
        return [];
    }
    if (records && records.length > 10) {
        //if array has more then 10 records, only keep the last 9 records
        const startIndex = records.length - 9;
        records = records.slice(startIndex);
    }
    if (records && records.length) {
        //es375: in some corner case the field zipcode & stateCode will be array,if yes change them to item
        for (let i = 0; i < records.length; i++) {
            const item = records[i];
            if (Array.isArray(item.zipcode)) {
                if (item.zipcode.length) {
                    item.zipcode = item.zipcode[0];
                } else {
                    item.zipcode = undefined;
                }
            }
            if (Array.isArray(item.stateCode)) {
                if (item.stateCode.length) {
                    item.stateCode = item.stateCode[0];
                } else {
                    item.stateCode = undefined;
                }
            }
        }
        return records;
    }
    const newRecords = [];
    for (const key in records) {
        const oldR = records[key];
        const count = oldR.count;
        const disabled = oldR.disabled;
        let newR;
        if (!disabled && oldR.info) {
            let isUpdate = false;
            for (let j = 0; j < newRecords.length; j++) {
                newR = newRecords[j];
                if (newR.zipcode == oldR.info.zipcode) {
                    if (_valideBed(oldR.info.propertyType)) {
                        newR.minBed = isNaN(oldR.info.minBed) ? newR.minBed : isNaN(newR.minBed) ? oldR.info.minBed : Math.min(oldR.info.minBed, newR.minBed);
                        newR.maxBed = isNaN(oldR.info.maxBed) ? newR.maxBed : isNaN(newR.maxBed) ? oldR.info.maxBed : Math.max(oldR.info.maxBed, newR.maxBed);
                    }
                    newR.minPrice = isNaN(oldR.info.minPrice) ? newR.minPrice : isNaN(newR.minPrice) ? oldR.info.minPrice : Math.min(oldR.info.minPrice, newR.minPrice);
                    newR.maxPrice = isNaN(oldR.info.maxPrice) ? newR.maxPrice : isNaN(newR.maxPrice) ? oldR.info.maxPrice : Math.max(oldR.info.maxPrice, newR.maxPrice);
                    if (newR.propertyType.indexOf(oldR.propertyType) === -1) {
                        newR.propertyType.push(oldR.propertyType);
                    }
                    newR.count = oldR.count;
                    isUpdate = true;
                    break;
                }
            }
            if (!isUpdate) {
                newR = {
                    minPrice: oldR.info.minPrice,
                    maxPrice: oldR.info.maxPrice,
                    propertyType: [oldR.info.propertyType],
                    propertyTypeDisplayName: oldR.info.propertyTypeDisplayName,
                    stateCode: oldR.info.stateCode,
                    zipcode: oldR.info.zipcode,
                    count: count || 0,
                    disabled: false,
                    updateTime: new Date(),
                };
                if (_valideBed(newR.propertyType)) {
                    newR.minBed = oldR.info.minBed;
                    newR.maxBed = oldR.info.maxBed;
                }
                newRecords.push(newR);
            }
        }
    }
    setStorage('saveSearchRecord', newRecords);
    return newRecords;
}

function _refreshUI() {
    let count = 0;
    const records = _getRecords();
    let hasRecords = false;
    for (let i = 0; i < records.length; i++) {
        if (!records[i].disabled) {
            count++;
        }
        hasRecords = true;
    }
    const menuCountElements = document.querySelectorAll('.menu-count.notification');
    menuCountElements.forEach(function (item) {
        const linkElement = item.closest('a');
        if (!count) {
            linkElement.setAttribute('disabled', 'disabled');
        }
        if (hasRecords) {
            linkElement.removeAttribute('disabled');
        } else {
            linkElement.setAttribute('disabled', 'disabled');
        }
    });
}

function _listingToRecord(listing) {
    if (!listing.propertyType || !listing.geo.zipcode) {
        return null;
    }
    const record = {
        zipcode: listing.geo.zipcode,
        minPrice: isNaN(listing.price) ? NaN : Math.floor(listing.price * 0.75),
        maxPrice: isNaN(listing.price) ? NaN : Math.floor(listing.price * 1.1),
        propertyType: [listing.propertyType],
        propertyTypeDisplayName: listing.propertyTypeDisplay,
        stateCode: listing.geo.stateCode,
        count: 1,
        disabled: false,
        updateTime: new Date(),
    };
    if (_valideBed(record.propertyType)) {
        record.minBed = isNaN(listing.bed) ? NaN : listing.bed * 1;
        record.maxBed = isNaN(listing.bed) ? NaN : listing.bed * 1 + 1;
    }
    return record;
}

function _updateRecord(oldR, newR) {
    if (!oldR || oldR.zipcode !== newR.zipcode) {
        return newR;
    }
    const mergeRecord = {
        zipcode: oldR.zipcode,
        updateTime: new Date(),
        disabled: oldR.disabled || newR.disabled,
        minPrice: isNaN(oldR.minPrice) ? newR.minPrice : isNaN(newR.minPrice) ? oldR.minPrice : Math.min(oldR.minPrice, newR.minPrice),
        maxPrice: isNaN(oldR.maxPrice) ? newR.maxPrice : isNaN(newR.maxPrice) ? oldR.maxPrice : Math.max(oldR.maxPrice, newR.maxPrice),
        propertyTypeDisplayName: newR.propertyTypeDisplayName || oldR.propertyTypeDisplayName,
    };
    if (newR.count >= 0) {
        if (oldR.count >= 0) {
            mergeRecord.count = oldR.count + newR.count;
        } else {
            mergeRecord.count = newR.count++ || 1;
        }
    } else {
        mergeRecord.count = oldR.count++ || 1;
    }
    mergeRecord.propertyType = mergeArray(oldR.propertyType, newR.propertyType);
    mergeRecord.stateCode = (Array.isArray(oldR.stateCode) ? oldR.stateCode[0] : oldR.stateCode) || newR.stateCode;

    if (_valideBed(newR.propertyType)) {
        mergeRecord.minBed = isNaN(oldR.minBed) ? newR.minBed : isNaN(newR.minBed) ? oldR.minBed : Math.min(oldR.minBed, newR.minBed);
        mergeRecord.maxBed = isNaN(oldR.maxBed) ? newR.maxBed : isNaN(newR.maxBed) ? oldR.maxBed : Math.max(oldR.maxBed, newR.maxBed);
    } else {
        mergeRecord.minBed = oldR.minBed;
        mergeRecord.maxBed = oldR.maxBed;
    }
    return mergeRecord;
}

function _recordToSubscription(data) {
    return {
        zipcode: data.zipcode,
        minBed: data.minBed,
        maxBed: data.maxBed,
        minPrice: data.minPrice,
        maxPrice: data.maxPrice,
        propertyType: data.propertyType,
        state: data.stateCode,
        isTokenActive: !data.disabled,
    };
}

function _subscriptionToRecord(subscription) {
    if (!subscription.zipcode || !subscription.propertyType || !subscription.propertyType.length) {
        return null;
    }
    return {
        count: 0,
        zipcode: subscription.zipcode,
        propertyType: subscription.propertyType,
        disabled: !subscription.isTokenActive,
        maxBed: subscription.maxBed * 1,
        maxPrice: subscription.maxPrice * 1,
        minBed: subscription.minBed * 1,
        minPrice: subscription.minPrice * 1,
        stateCode: subscription.state,
        fromServer: true,
        updateTime: new Date(subscription.updateDate ? subscription.updateDate : subscription.tokenCreatedDate),
    };
}

export function checkPermission() {
    return window.Notification && Notification.permission;
}

export function checkBlocked() {
    return window.Notification && window.Notification.permission === 'denied';
}

export function checkAllowed() {
    return window.Notification && window.Notification.permission === 'granted';
}

export function createNotification(title, text, icon) {
    try {
        return new Notification(title, {
            body: text,
            icon: icon,
        });
    } catch (e) {
        return null;
    }
}

export function initial() {
    context = window.__INITIAL_STATE__;
    supportServiceWork = window.navigator && window.navigator.serviceWorker;
    if (!supportServiceWork) {
        gaEventTrack('pushNotification', 'pushNotification', 'NotificationNoServiceWork');
    }
    if (!window.Notification) {
        return;
    }
    if (checkBlocked()) {
        setStorage('lastTime', null);
        return;
    }
    anonymousId = getCookie('ajs_anonymous_id');
    safariNotification = window.safari && window.safari.pushNotification;
    browserType = getBrowserType();
    isSafari = browserType === 'safari';
    defaultPayload = {
        browser: browserType,
        novaId: context.user.id || '',
        gaId: getCookie('MOVOTODEVICEID') || context.movotoDeviceID,
        anonymousId: anonymousId ? anonymousId.replace(/'|"/g, '') : '',
        pageUrl: window.location.href,
        appType: 'web',
    };
    defaultNotificationOptions = {
        icon: context.cdnUrl + 'images/desktop/manifest/icon-192x192.png',
        url: context.appUrl + 'for-sale/',
    };
    // Call _refreshUI when page is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', _refreshUI, { once: true });
    } else {
        _refreshUI();
    }
    // Keep the event listener for future subscription updates
    document.addEventListener('dom.load.subscriptionUpdate', _refreshUI, { once: true });
    initNotification();
}

export function valideBed(type) {
    return _valideBed(type);
}

export function getUrlByRecord(data, withoutDomain) {
    return _getUrlByRecord(data, withoutDomain);
}

export function getRecords() {
    return _getRecords();
}

export function updateSubscriptionBySubscription(param) {
    return new Promise((resolve) => {
        addNotificationInitializedListener(() => {
            _updateSubscriptionBySubscription(param).then(function (e) {
                resolve(e);
            });
        });
    });
}

export function updateSubscriptionByListing(param) {
    return new Promise((resolve) => {
        addNotificationInitializedListener(() => {
            _updateSubscriptionByListing(param).then(function (e) {
                resolve(e);
            });
        });
    });
}

export function deleteSubscription(param) {
    return new Promise((resolve) => {
        addNotificationInitializedListener(() => {
            _deleteSubscription(param).then(function (e) {
                resolve(e);
            });
        });
    });
}

export function disableSubscription(param) {
    return new Promise((resolve) => {
        addNotificationInitializedListener(() => {
            _disableSubscription(param).then(function (e) {
                resolve(e);
            });
        });
    });
}

export function enableSubscription(param) {
    return new Promise((resolve) => {
        addNotificationInitializedListener(() => {
            _enableSubscription(param).then(function (e) {
                resolve(e);
            });
        });
    });
}

export function toggleAllSubscriptions(blocked) {
    return new Promise((resolve) => {
        addNotificationInitializedListener(() => {
            allowSubscriptions(blocked).then(function (e) {
                resolve(e);
            });
        });
    });
}
